export default "__VITE_ASSET__BjQauxze__"